import { render } from "./KeyWord.vue?vue&type=template&id=ef49fb34&scoped=true"
import script from "./KeyWord.vue?vue&type=script&lang=js"
export * from "./KeyWord.vue?vue&type=script&lang=js"

import "./KeyWord.vue?vue&type=style&index=0&id=ef49fb34&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef49fb34"]])

export default __exports__